import { Component as BaseComponent, h } from 'preact';
import { connect } from 'react-redux';
import _ from 'underscore';
import SelectGroup from '../../form/select-group';

class Component extends BaseComponent {
    constructor(props) {
        super(props);

        this.state = { disabled: true };

        this.decks = {};

        let slug = 'universal-waite';

        props.decks.map(deck => {
            if (deck.deck == props.user.favorite_deck_id) {
                this.state.value = deck.slug;
            }

            this.decks[deck.slug] = deck.name;

            if (props.user && !isNaN(props.user.favorite_deck_id) && props.user.favorite_deck_id == deck.deck) {
                slug = deck.slug;
            }
        });

        props.requireDeck(slug);

        props.settingsUpdate({
            success: false,
            errors: [],
        });
    }

    shouldComponentUpdate(nextProps, nextState) {
        if (nextProps.deck != this.props.deck) {
            return true;
        }

        if (nextState.disabled != this.state.disabled) {
            return true;
        }

        if (nextState.value != this.state.value) {
            return true;
        }

        if (nextProps.settings != this.props.settings) {
            return true;
        }

        return false;
    }

    render(props, { value, disabled }) {
        return (
            <your-tarot-deck>
                <p className='has-padding-20-top'>Choose the deck you prefer to use in your Tarot readings:</p>
                <row className='is-wrap has-margin-30-top is-aligned-center'>
                    <column className='is-5 is-12-mobile has-text-center'>
                        {this.renderDeckImage()}
                    </column>
                    <column className='is-5 is-12-mobile has-padding-15-top-mobile'>
                        <SelectGroup
                            label='Your default deck'
                            name='favorite_deck_id'
                            value={value}
                            placeholder='SELECT TAROT DECK'
                            options={this.decks}
                            onChange={this.handleChange}
                        />
                        <button
                            className={`button ${disabled ? 'disabled' : ''}`}
                            onClick={this.submit}
                            disabled={disabled}
                        >
                            SAVE CHANGES
                        </button>
                        {this.renderMessage()}
                    </column>
                </row>
            </your-tarot-deck>
        );
    }

    renderDeckImage = () => {
        const slug = this.props.deck ? this.props.deck.slug : 'universal-waite';
        const name = this.props.deck ? this.props.deck.name : 'Universal Waite';

        return (
            <img
                src={`https://gfx.tarot.com/images/decks/deck-image/${slug}.jpg`}
                alt={name}
            />
        );
    }

    renderMessage = () => {
        if (this.props.settings && this.props.settings.errors && this.props.settings.errors.favorite_deck_id) {
            return (<p className='is-error'>{this.props.settings.errors.favorite_deck_id}</p>);
        } else if (this.props.settings && this.props.settings.success) {
            return (<p className='is-success'>Your Tarot Deck has been saved!</p>);
        }

        return null;
    }

    handleChange = (e) => {
        this.setState({
            value: e.target.value,
            disabled: false,
        });

        this.props.requireDeck(e.target.value);

        const deck = _.findWhere(this.props.decks, { slug: e.target.value });

        this.props.settingsUpdate({
            success: false,
            errors: [],
            fields: {
                favorite_deck_id: deck.deck,
            },
            error: null,
            dirty: true,
        });
    }

    submit = (e) => {
        e.preventDefault();
        this.props.memberUpdate();
        this.setState({ disabled: true });
    }
}

const mapStateToProps = (state) => ({
    deck: state.deck,
    decks: state.decks,
    user: state.user,
    settings: state.settings,
});

const mapDispatchToProps = (dispatch) => ({
    requireDeck: (deck) => dispatch({ type: 'deck:required', payload: deck }),
    memberUpdate: () => dispatch({ type: 'member:update-settings' }),
    settingsUpdate: (payload) => dispatch({ type: 'settings:update', payload: payload }),
});

export default connect(mapStateToProps, mapDispatchToProps)(Component);
